<template>
  <div class="flex flex-wrap mb-2" :style="guideStep >= 35 && guideStep <= 39 ? { zIndex: 100, position: 'relative' } : null">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6">
      <div>
        <!-- <span class="text-red-500">*</span> -->
        <span class="text-grap-700 align-middle">{{lang['components']['Event']['Regions']['title']}}</span>
        <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip="'tooltip'"></i> -->
        <button
          v-if="false"
          id="regions"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['Regions']['video_teaching']}}
        </button>
      </div>
      <div class="flex-1 space-y-4">
        <!-- 新手教學 -->
        <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 36, 'cursor-not-allowed': editPageType === true }">
          <div>
            <span v-if="!editPageType" class="text-red-500">*</span>
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Regions']['place_title']}}</span>
            <i v-if="false" class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="`${lang['components']['Event']['Regions']['place_title_info']}`"></i>
          </div>
          <!-- <Dropdown :disabled="editPageType" v-model="viewDatalistData.location_types" :options="types" optionLabel="name" optionValue="code" :placeholder="lang['components']['Event']['Regions']['place_title_placeholder']"
            class="w-1/3 rounded-md" @change="locationTypes($event)" /> -->
          <!-- 新手教學 -->
          <!-- <div class="flex flex-wrap bg-gray-50 w-full p-2 rounded-md border text-gray-600"
            v-if="selectCountriesData" :class="{ 'ring-4 border-blue-400': guideStep === 37 }">
            <template v-for="(item, index) in selectCountriesData" :key="index">
              <div class="flex justify-between w-full rounded m-1 p-2 text-sm bg-white border border-gray-200" @click="removeLocations(index)">
                <span>{{ item.name }}</span>
                <i class="pi pi-times mt-1" v-if="!editPageType"></i>
              </div>
            </template>
          </div> -->
          <!-- <div v-if="!editPageType" class=" bg-white rounded-md flex items-center w-full p-2 shadow-sm border border-gray-200">
            <i class="pi pi-search"></i>
            <input type="search" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
              :placeholder="lang['components']['Event']['Regions']['place_input_placeholder']" :disabled="editPageType" v-model="searchPlace" v-on:keyup="keyup_get_country();">
          </div>
          <Listbox :disabled="editPageType" v-model="country" :options="locations" optionLabel="name" optionValue="key" class="w-full rounded-md"
            emptyMessage="Loading..." v-if="searchPlace.length > 0" /> -->
          <MultiSelect v-model="viewDatalistData.locations_selected" filter :options="viewDatalistData.locations_list" optionDisabled="disabled" optionLabel="name" optionValue="code" class="w-full multiselect-custom" :disabled="editPageType" style="max-width: 58rem; "/>
        </div>
        <!-- 新手教學 -->
        <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 38, 'cursor-not-allowed': editPageType === true }">
          <div>
            <!-- <span class="text-red-500">*</span> -->
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Regions']['lang_title']}}</span>
            <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="`${lang['components']['Event']['Regions']['lang_title_info']}`"></i>
          </div>
          <!-- <div class="flex flex-wrap bg-gray-50 w-full p-2 rounded-md border text-gray-600"
            v-if="selectLangsData">
            <template v-for="(lang, index) in selectLangsData" :key="index">
              <div class="flex justify-between w-full rounded m-1 p-2 text-sm bg-white border border-gray-200" @click="removeLocales(index)">
                <span>{{ lang.name }}</span>
                <i class="pi pi-times mt-1" v-if="!editPageType"></i>
              </div>
            </template>
          </div> -->
          <!-- <div v-if="!editPageType" class=" bg-white rounded-md flex items-center w-full p-2 shadow-sm border border-gray-200">
            <i class="pi pi-search"></i>
            <input type="search" class="w-full pl-4 text-sm outline-none focus:outline-none bg-transparent"
              :placeholder="lang['components']['Event']['Regions']['lang_input_info']" :disabled="editPageType" v-model="searchLang" v-on:keyup="keyup_get_lang();">
          </div>
          <Listbox :disabled="editPageType" v-model="langInput" :options="locale" optionLabel="name" optionValue="key" class="w-full rounded-md"
            emptyMessage="Loading..." v-if="searchLang.length > 0" /> -->
          <MultiSelect v-model="viewDatalistData.locales_selected" filter :options="viewDatalistData.locales_list" optionDisabled="disabled" optionLabel="name" optionValue="code" class="w-full multiselect-custom" :disabled="editPageType" style="max-width: 58rem; "/>
        </div>
        <!-- 新手教學 -->
        <div class="space-y-2 pb-8" :class="{ 'ring-4 border-blue-400': guideStep === 39, 'cursor-not-allowed': editPageType === true }">
          <div>
            <span v-if="!editPageType" class="text-red-500">*</span>
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Regions']['gender_title']}}</span>
            <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'性別'"></i> -->
          </div>
          <div class="flex flex-wrap space-x-8" :class="{ 'cursor-not-allowed': editPageType === true }">
            <SelectButton v-model="viewDatalistData.gender" :options="gender_list" optionLabel="name" :disabled="editPageType" aria-labelledby="multiple" >
              <template #option="slotProps">
                <div :class="{ 'cursor-not-allowed': editPageType === true,  'cursor-pointer': editPageType === false }">
                  <p>
                    {{ slotProps.option.name }}
                  </p>
                </div>
              </template>
            </SelectButton>
          </div>
        </div>
        <div class="space-y-2 pb-8">
          <div>
            <span v-if="!editPageType" class="text-red-500">*</span>
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Regions']['age_title']}}</span>
            <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'預算比率'"></i> -->
          </div>
          <div class="flex flex-wrap" :class="{ 'cursor-not-allowed': editPageType === true }">
            <!-- <Dropdown v-model="viewDatalistData.age_min" :disabled="targetDMData || editPageType" optionLabel="name" optionValue="code" :options="age_interval" class="w-30 rounded-md old-left" />
            <Dropdown v-model="viewDatalistData.age_max" :disabled="targetDMData || editPageType" optionLabel="name" optionValue="code" :options="age_interval" class="w-30 rounded-md old-right" /> -->
            <SelectButton v-model="viewDatalistData.age_groups" :options="age_list" optionLabel="name" multiple :disabled="editPageType" aria-labelledby="multiple" >
              <template #option="slotProps">
                <div :class="{ 'cursor-not-allowed': editPageType === true,  'cursor-pointer': editPageType === false }">
                  <p>
                    {{ slotProps.option.name }}
                  </p>
                </div>
              </template>
            </SelectButton>
          </div>
        </div>
      </div>
    </div>
    <div class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;"></div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
</template>
<script>
  import Dropdown from 'primevue/dropdown';
  import Listbox from 'primevue/listbox';
  import RadioButton from 'primevue/radiobutton';
  import SelectButton from 'primevue/selectbutton';
  import MultiSelect from 'primevue/multiselect';
  import Swal from 'sweetalert2/dist/sweetalert2.js'
  import 'sweetalert2/dist/sweetalert2.min.css'
  import Vue3DraggableResizable from 'vue3-draggable-resizable'
  import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
  import axios from 'axios'
  import Qs from 'qs'

  export default {
    name: 'Regions',
    components: {
      Dropdown,
      Listbox,
      RadioButton,
      SelectButton,
      MultiSelect
    },
    props: {
      // <!-- 新手教學 -->
      guideStep: {
        type: Number,
        default: 1
      },
      // <!-- 新手教學 -->
      editPage: {
        type: Boolean
      },
      viewDatalist: {
        type: Object
      },
      selectCountries: {
        type: Object
      },
      selectLangs: {
        type: Object
      },
      targetDM: {
        type: Boolean
      },
      lang: {
        type: Object
      },
      youtubeClose: {
        type: Boolean
      },
      efficientAi: {
        type: Boolean
      }
    },
    data() {
      return {
        type: 'home',
        types: [
          { name: "位於此地點的所有人", code: 'home,recent' },
          { name: "居住在此地點的人", code: 'home' },
          { name: "最近在此地點的人", code: 'recent' },
          { name: "在此地點旅行的人", code: 'travel_in' }
        ],
        country: null,
        langInput: null,
        // selectCountries: [],
        // selectLangs: [],
        countries: [{
            name: '臺灣'
          },
          {
            name: '日本'
          },
          {
            name: '美國'
          },
        ],
        locale: [],
        locale_mark: [],
        locations: [],
        locations_mark: [],
        searchPlace: '',
        searchLang: '',
        // gender: 1,
        oldstart: 46,
        oldend: 64,
        oldS: [
          45, 46, 47, 48
        ],
        oldE: [
          61, 62, 63, 64, '65+'
        ],
        age_interval:[],
        x: 0,
        y: 0,
        h: 200,
        w: 320,
        active: false,
        src: "https://www.youtube.com/watch?v=6vD-2v5RWyk",
        vars: {
          rel: 0,
          start: 0,
          end: 0,
        },
        view_youtube: false,
        efficientAiStatus: true,
        gender_value: [{ name: '不限', value: 'GENDER_UNLIMITED' }],
        gender_list: [
            { name: '不限', value: 'GENDER_UNLIMITED' },
            { name: '男性', value: 'GENDER_MALE' },
            { name: '女性', value: 'GENDER_FEMALE' }
        ],
        age_value: [{ name: '不限', value: 'IS_NULL' }],
        age_list: [
            { name: '不限', value: 'IS_NULL' },
            { name: '13-17', value: 'AGE_13_17' },
            { name: '18-24', value: 'AGE_18_24' },
            { name: '25-34', value: 'AGE_25_34' },
            { name: '35-44', value: 'AGE_35_44' },
            { name: '45-54', value: 'AGE_45_54' },
            { name: '55+', value: 'AGE_55_100' }
        ]
      }
    },
    created() {
      console.log('this.viewDatalistData.age_min');
      console.log(this.viewDatalistData.age_min);
      if(this.age_interval.length <= 0){
        console.log('created');
        for(let i = 18; i < 66; i++){
          let name = i;
          let code = i;

          if(i == 65){
            name = '65+';
          }

          this.age_interval.push({name: name, code: code});
        }
        console.log(this.age_interval);
      }
    },
    watch: {
      'youtubeClose':function(v){
        console.log('marketingmethod youtubeClose');
        console.log(v);

        let _tmpYoutubeType = v.split('_');

        console.log('_tmpYoutubeType');
        console.log(_tmpYoutubeType);

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);

        if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
          if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'regions'){
            this.view_youtube = false
          }
        }

        console.log(typeof this.view_youtube);
        console.log(this.view_youtube);
      },
      'efficientAi': function(v){
        console.log('regions efficientAi');
        console.log(v);
        this.efficientAiStatus = v
      },
      'lang':function(v){
        console.log('regions this.lang');
        console.log(this.lang);
        this.types = [
          { name: this.lang['components']['Event']['Regions']['types_list']['home_recent'], code: 'home,recent' },
          { name: this.lang['components']['Event']['Regions']['types_list']['home'], code: 'home' },
          { name: this.lang['components']['Event']['Regions']['types_list']['recent'], code: 'recent' },
          { name: this.lang['components']['Event']['Regions']['types_list']['travel_in'], code: 'travel_in' }
        ];
      },
      'viewDatalistData.locations_selected': function(v){
        console.log('viewDatalistData.locations_selected');
        console.log(v);
      },
      'viewDatalistData.locales_selected': function(v){
        console.log('viewDatalistData.locales_selected');
        console.log(v);
      },
      'viewDatalistData.gender': function(v){
        console.log('viewDatalistData.gender');
        console.log(v);
      },
      country(v) {
        // console.log('country');
        // console.log(v);

        var inArray = 0

        for (let i = 0; i < this.selectCountriesData.length; i++) {
          if (this.selectCountriesData[i].key === v) {
            inArray = 1
          }
        }

        if(inArray == 0 && v != null){
          this.selectCountriesData.push(this.locations_mark[v])
        }

        this.$emit('update:selectCountries', this.selectCountriesData)
        this.searchPlace = ''

        // console.log(this.selectCountriesData);
      },
      langInput(v) {
        // console.log('lang');
        // console.log(v);
        // this.selectLangs.push(v)
        var inArray = 0

        if(this.selectLangsData != null && this.selectLangsData != '' && this.selectLangsData != 'undefined'){
          for (let i = 0; i < this.selectLangsData.length; i++) {
            if (this.selectLangsData[i].key === v) {
              inArray = 1
            }
          }
        }

        if(inArray == 0 && v != null){
          this.selectLangsData.push(this.locale_mark[v])
        }

        this.$emit('update:selectLangs', this.selectLangsData)
        this.searchLang = ''

        // console.log(this.selectLangsData);
      },
      selectCountries(v){
        // console.log('regions selectCountries:'+v);
      },
      'viewDatalistData.age_min'(value){
        if(this.viewDatalistData.age_min < 18){
          this.age_interval = [];
          for(let i = 13; i < 66; i++){
            let name = i;
            let code = i;

            if(i == 65){
              name = '65+';
            }

            this.age_interval.push({name: name, code: code});
          }
        }
        console.log(this.age_interval);

        console.log('viewDatalistData.age_min');
        console.log(value);
        // console.log('viewDatalistData.age_max');
        // console.log(this.viewDatalistData.age_max);

        let age_max = this.viewDatalistData.age_max;

        if(value > age_max){
          Swal.fire(
                      this.lang['components']['Event']['Regions']['watch']['viewDatalistData_age_min']['swal_title'],
                      this.lang['components']['Event']['Regions']['watch']['viewDatalistData_age_min']['swal_text'],
                      "warning"
                    )
        }
      },
      'viewDatalistData.age_max'(value){
        // console.log('viewDatalistData.age_min');
        // console.log(this.viewDatalistData.age_min);
        console.log('viewDatalistData.age_max');
        console.log(value);

        let age_min = this.viewDatalistData.age_min;

        if(age_min > value){
          Swal.fire(
                      this.lang['components']['Event']['Regions']['watch']['viewDatalistData_age_max']['swal_title'],
                      this.lang['components']['Event']['Regions']['watch']['viewDatalistData_age_max']['swal_text'],
                      "warning"
                    )
        }
      },
      'viewDatalistData.age_groups'(v){
        console.log('viewDatalistData.age_groups');
        console.log(v);

        if(v.length > 0){
          let lastItem = v[v.length - 1];
          // console.log(lastItem);
          // console.log(lastItem.value);

          if(lastItem.value == 'IS_NULL' && v.length > 1){
            this.viewDatalistData.age_groups = [{ name: '不限', value: 'IS_NULL' }];
          }

          if(lastItem.value != 'IS_NULL' && v.length > 1){
            for(let i = 0; i < v.length; i++){
              // console.log('v.length');
              // console.log(v[i]);

              if(v[i].value == 'IS_NULL'){
                this.viewDatalistData.age_groups.splice(i, 1);
              }
            }
          }
        }

        // this.viewDatalistData.age_groups = this.age_value;

        console.log('this.viewDatalistData.age_groups');
        console.log(this.viewDatalistData.age_groups);
      }
    },
    methods: {
      onReady() {
        console.log('youtube');
        this.$refs.youtube.playVideo()
        // this.$refs.youtube.pauseVideo()
      },
      onStateChange(e){
        console.log(e);

        if(e.data == 0){
          this.view_youtube = false
        }
      },
      teachVideo(){
        this.$emit('checkClose')
        // let elem = document.getElementById('marketingDate');
        // let positio = this.getPosition(elem);
        // console.log('x:'+positio.x);
        // console.log('y:'+positio.y);

        // this.x = positio.x + parseInt(80);
        // this.y = positio.y

        var windowWidth = window.innerWidth;
        var windowHeight = window.innerHeight;

        // console.log('windowWidth');
        // console.log(windowWidth);
        // console.log('windowHeight');
        // console.log(windowHeight);

        this.x = windowWidth - parseInt(390);
        this.y = windowHeight - parseInt(350);

        this.view_youtube = true;
        this.$emit('childYoutube', 'true_regions')

        this.vars.start = 228
        this.vars.end = 260
      },
      getPosition(element) {
        let x = 0;
        let y = 0;

        while ( element ) {
          x += element.offsetLeft - element.scrollLeft + element.clientLeft;
          y += element.offsetTop - element.scrollLeft + element.clientTop;
          element = element.offsetParent;
        }

        return { x: x, y: y };
      },
      print(val) {
        console.log(val)
      },
      doDragging(){
        console.log('doDragging');
      },
      locationTypes(event) {
        // console.log('locationTypes');
        // console.log(event.value);
      },
      removeLocations(index) {
        // console.log('remove');
        // console.log(index);
        if(this.editPageType == false){
          this.selectCountriesData.splice(index, 1);

          this.$emit('update:selectCountries', this.selectCountriesData)

        }
      },
      removeLocales(index) {
        // console.log('remove');
        // console.log(index);
        if(this.editPageType == false){
          this.selectLangsData.splice(index, 1);

          this.$emit('update:selectLangs', this.selectLangsData)
        }
      },
      keyup_get_lang(){
        // console.log('searchLang');
        // console.log(this.searchLang);

        this.langInput = null
        this.locale = null

        if(this.editPageType == false){
          axios
            .post('https://test.autoturn.net/inside/api/campaign_form_locale_search.php', Qs.stringify({
              s_code: this.$route.params.id,
              q: this.searchLang
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                this.locale = response.data.return_data
                this.locale_mark = response.data.return_data_mark
              }
            });
        }
      },
      keyup_get_country(){
        // console.log('searchPlace');
        // console.log(this.searchPlace);
        // console.log('selectCountriesData');
        // console.log(this.selectCountriesData);
        // console.log('country');
        // console.log(this.country);

        this.country = null
        this.locations = null

        if(this.editPageType == false){
          axios
            .post('https://test.autoturn.net/inside/api/campaign_form_locations_search.php', Qs.stringify({
              s_code: this.$route.params.id,
              q: this.searchPlace
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                this.locations = response.data.return_data
                this.locations_mark = response.data.return_data_mark
              }
            });
          }
      }
    },
    computed: {
      editPageType: {
        get: function () {
          return this.editPage
        },
        set: function (value) {
          this.$emit('update:editPageType', value)
        },
      },
      viewDatalistData: {
        get: function () {
          return this.viewDatalist
        },
        set: function (value) {
          this.$emit('update:viewDatalistData', value)
        },
      },
      selectCountriesData: {
        get: function () {
          return this.selectCountries
        },
        set: function (value) {
          this.$emit('update:selectCountriesData', value)
        },
      },
      selectLangsData: {
        get: function () {
          return this.selectLangs
        },
        set: function (value) {
          this.$emit('update:selectLangsData', value)
        },
      },
      targetDMData: {
        get: function () {
          return this.targetDM
        },
        set: function (value) {
          this.$emit('update:targetDMData', value)
        },
      }
    }
  }
</script>

<style lang="scss" scoped>
  ::v-deep() {
    .old-left {
      border-top-right-radius: 0px;
      border-bottom-right-radius: 0px;
      border-right: 0px;
    }

    .old-right {
      border-top-left-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
</style>